import React from 'react';
import { Button } from './primitives';
import { FOUNDER_FORM_HREF, MENTOR_FORM_HREF } from '../content';
import { SCENE_IMG, PORTRAIT } from '../media';
export function TwoDoors() {
  return <section id="join" className="theme-dark relative overflow-hidden bg-background text-foreground" aria-label="Join basecamp" data-id="element-110" data-mp="bvvkg9vgiqnh">
      <img src={SCENE_IMG.twinLakes} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_35%]" data-id="element-111" data-mp="gsluogkkys0z" />
      <div className="absolute inset-0 bg-[rgba(0,31,15,0.72)]" data-id="element-112" data-mp="6wsemn7nkgeg" />

      <div className="section-shell relative grid gap-5 py-16 md:grid-cols-2 lg:py-20" data-id="element-113" data-mp="6twgaxrw7pph">
        <article id="founders-door" className="flex scroll-mt-32 flex-col rounded-lg border border-border bg-background/70 p-8 backdrop-blur-sm lg:p-10" aria-labelledby="founders-door-heading" data-id="element-114" data-mp="3p3ynrvvlwm2l">
          <p className="overline" data-id="element-115" data-mp="1sa5811rvkbd9">Founders</p>
          <h2 id="founders-door-heading" className="mt-5 font-serif text-h3" data-id="element-116" data-mp="1s93lo15es2g8">
            Building something inspired by nature?
          </h2>
          <p className="mt-4 max-w-md text-body leading-body text-muted-foreground" data-id="element-117" data-mp="2e14dfv27rgsp">
            Tell us about it and where you&rsquo;re headed next. We read every one.
          </p>

          {/* Who actually reads them. */}
          <figure className="m-0 mt-6 flex items-center gap-4" data-id="element-118" data-mp="2mu7nruhkbdj4">
            <img src={PORTRAIT.natalya} alt="Natalya Wallin" loading="lazy" className="h-14 w-14 shrink-0 rounded-full object-cover object-top" data-id="element-119" data-mp="1z3lpguxd17mb" />
            <figcaption data-id="element-120" data-mp="292b0c3qu9rt2">
              <p className="text-body-sm font-semibold" data-id="element-121" data-mp="292krhunme50c">Natalya Wallin</p>
              <p className="text-caption text-muted-foreground" data-id="element-122" data-mp="2425ex5b5x1jf">Chief Executive Officer</p>
            </figcaption>
          </figure>

          <div className="mt-auto pt-8" data-id="element-123" data-mp="3kfdgixp10fcp">
            <Button href={FOUNDER_FORM_HREF} data-id="element-124" data-mp="3fhu4m4fswenx">Tell us about you</Button>
          </div>
        </article>

        <article id="mentors-door" className="flex scroll-mt-32 flex-col rounded-lg border border-border bg-background/70 p-8 backdrop-blur-sm lg:p-10" aria-labelledby="mentors-door-heading" data-id="element-125" data-mp="3nijixxdfucbw">
          <p className="overline" data-id="element-126" data-mp="evc28skn8kx">Mentors</p>
          <h2 id="mentors-door-heading" className="mt-5 font-serif text-h3" data-id="element-127" data-mp="bqxqile6wgj">
            Been up this mountain before?
          </h2>
          <p className="mt-4 max-w-md text-body leading-body text-muted-foreground" data-id="element-128" data-mp="33v2ekbz92zs4">
            Help someone else climb it faster.
          </p>
          <div className="mt-auto pt-8" data-id="element-129" data-mp="38u6q399nd9lm">
            <Button href={MENTOR_FORM_HREF} data-id="element-130" data-mp="3dt0370l0uyl9">Become a mentor</Button>
          </div>
        </article>
      </div>
    </section>;
}